<template>
  <div style="position: relative;width: 100vw;height: 100vh;">
    <!-- <div class="loginBgimg"></div> -->
    <starAnimation />
    <div class="loginNavBox">
      <!-- <div class="maxBox">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
          @keyup.native.enter="submitForm('ruleForm')">
          <div class="loginTitle">网艺圈 · 后台管理系统</div>
          <el-form-item label="账号" prop="userInfo">
            <el-input type="text" v-model.trim="ruleForm.userInfo" autocomplete="off" ref="userFoc"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="checkPass">
            <el-input type="password" v-model.trim="ruleForm.checkPass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loginbtnBol" @click="submitForm('ruleForm')">
              {{ loginbtnBol ? '登录中' : '登录' }}
            </el-button>
          </el-form-item>
        </el-form>
      </div> -->
      <div class='titleCls'>
        <h1 class="titleText">网艺圈&nbsp;·&nbsp;后台系统</h1>
      </div>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm"
        @keyup.native.enter="submitForm('ruleForm')">
        <el-form-item prop="userInfo">
          <el-input type="text" v-model.trim="ruleForm.userInfo" autocomplete="off" ref="userFoc"
            placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
          <el-input type="password" v-model.trim="ruleForm.checkPass" autocomplete="off" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loginbtnBol" @click="submitForm('ruleForm')"
            style="border: #1677ff 1px solid;background: #1677ff;width: 100%;">
            {{ loginbtnBol ? '登录中' : '登录' }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
import { loginApi, getUnreadNoticeCountApi } from '@/api/user'
import starAnimation from '@/components/starAnimation/starAnimation.vue'
export default {
  name: 'wyqLogin',
  components: {
    starAnimation
  },
  data() {
    const validatePass = (rule, value, callback) => {
      // 账号inp判断
      if (value === '') {
        callback(new Error('请输入账号'))
      } else {
        // 密码不等于空才会进入这个判断
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        // 判断出来之后的执行函数
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不能为空'))
      } else {
        callback()
      }
    }
    return {
      loginbtnBol: false,
      ruleForm: {
        userInfo: '',
        checkPass: ''
      },
      rules: {
        userInfo: [
          { validator: validatePass, trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]{1,20}$/, message: '请输入正确的账号' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]{6,20}$/, message: '请输入大于6小于20位长度密码' }
        ]
      }
    }
  },
  mounted() {
    this.enterHomeIfTokenValid()
  },
  methods: {
    enterHomeIfTokenValid() {
      const token = this.$store.state.tokenObj.token
      if (!token) return

      getUnreadNoticeCountApi().then(() => {
        this.$router.replace('/home')
      }).catch(() => {
        this.$store.commit('logout')
      })
    },
    // 登录点击事件
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loginbtnBol = true
          // 本地校验通过后发请求登录
          loginApi({
            userid: this.ruleForm.userInfo,
            password: this.ruleForm.checkPass
          }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '登录成功',
                type: 'success'
              })
              this.$store.commit('setToken', { value_key: 'token', value: res.data.access_token })
              this.$router.push('/home')
            } else {
              this.$message.error(res.msg)
            }
            this.loginbtnBol = false
            this.$refs.userFoc.focus()
          }).catch(err => {
            this.loginbtnBol = false
            this.$refs.userFoc.focus()
            console.log(err)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.loginNavBox {
  width: 450px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
}

.titleCls {
  width: 450px;
  margin-bottom: 40px;
  position: relative;

  h1 {
    font-weight: bold;
    font-size: 22px;
    text-align: center;
    color: #fff;
  }

  &:before,
  &:after {
    content: "";
    width: 100px;
    height: 2px;
    position: absolute;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), #1976D2);
    left: -20px;
    top: 18px;
  }

  &:after {
    left: auto;
    background: linear-gradient(to left, rgba(255, 255, 255, 0), #1976D2);
    right: -20px;
  }
}

::v-deep .el-input__inner {
  background: none;
  border-color: #1890ff;
  color: #fff;
}

// 页面背景图
.loginBgimg {
  z-index: -1;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  position: fixed;
  top: 0;
  /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
  background-attachment: fixed;
  /* 让背景图基于容器大小伸缩 */
  background-size: cover;
  // filter: blur(5px);
}

// 登录表单
.maxBox {
  width: 500px;
  height: 400px;
  margin: 120px auto 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);

  .el-form {
    padding-right: 60px;
  }

  .loginTitle {
    font-size: 18px;
    color: #409EFF;
    padding-bottom: 30px;
    padding-left: 60px;
  }

  .el-button {
    margin-right: 40px;
    width: 90px;
  }
}
</style>
